import {useParams} from 'react-router-dom';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {VendorDocumentTitle} from 'src/pages/Modules/Vendors/shared/vendorHelpers';
import {VendorForm} from 'src/pages/Modules/Vendors/shared/VendorForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

export const VendorEditPage = () => {
  useSetDocumentTitle(VendorDocumentTitle);
  const {vendorId} = useParams();

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Vendors}>
      <VendorForm id={Number(vendorId)} mode="edit" />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.VendorsEdit(':vendorId'),
  element: <VendorEditPage />,
  module: ModuleEnum.Vendors,
  operation: PermissionOperationEnum.Update,
  isPrivate: true,
});

export default VendorEditPage;
